import { render, staticRenderFns } from "./SuiviClients.vue?vue&type=template&id=ada22936&"
import script from "./SuiviClients.vue?vue&type=script&lang=js&"
export * from "./SuiviClients.vue?vue&type=script&lang=js&"
import style0 from "./SuiviClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports